export default {
  confirmation: {
    text: {
      en: 'Would you like to remove this item from your cart?',
    },
    no: {
      en: 'No, keep it',
    },
    yes: {
      en: 'Yes, remove it!',
    },
  },
}
